import { EventEmitter, Injectable } from '@angular/core';
import { MTMFileDownloadModel } from './mtm-file-download.model';

export const onDownloadStart: EventEmitter<any> = new EventEmitter<any>();
export const onDownloadComplete: EventEmitter<any> = new EventEmitter<any>();

@Injectable()
export class MTMFileDownloadService {
  downloadList: MTMFileDownloadModel[] = [];

  constructor() {}

  addFileToDownload(fileToDownload: MTMFileDownloadModel) {
    this.downloadList.push(fileToDownload);
  }

  startDownloadFile(downloadFile: MTMFileDownloadModel) {
    this.downloadList.push(downloadFile);
    downloadFile.startDownload();
  }

  getAllDownloadFile() {
    return this.downloadList;
  }
  isFileInDownload(downloadId: any) {
    return this.downloadList.find((downloadFile) => {
      return downloadFile.id === downloadId && (downloadFile.state === 'downloading' || downloadFile.state === 'start');
    });
  }

}
